import React, { useState, useEffect } from "react";

function Testimonials() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 2);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
    setIsAutoPlaying(false); // Stop auto-play when manually navigating
  };

  const goToPrevious = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + 2) % 2);
    setIsAutoPlaying(false);
  };

  const goToNext = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % 2);
    setIsAutoPlaying(false);
  };

  return (
    <>
      {/* Testimonial Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-4 mx-auto"
            style={{maxWidth: "600px"}}>
            <h5 className="fw-bold text-primary text-uppercase">Testimonial</h5>
            <h1 className="mb-0">What Our Clients Say About Our Digital Services</h1>
          </div>
          
          {/* React Carousel for All 5 Testimonials */}
          <div className="testimonial-carousel-container wow fadeInUp" data-wow-delay="0.6s">
            <div className="carousel-container position-relative">
              <div className="carousel-inner">
                {/* First Row - 3 Testimonials */}
                <div className={`carousel-item ${currentSlide === 0 ? 'active' : ''}`}>
                  <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                      <div className="testimonial-item bg-light rounded h-100">
                        <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                          <img
                            className="img-fluid rounded"
                            src="/img/user.png"
                            style={{width: "60px", height: "60px"}}
                            alt="Client"
                          />
                          <div className="ps-4">
                            <h4 className="text-primary mb-1">Robin White</h4>
                            <small className="text-uppercase">E-commerce</small>
                          </div>
                        </div>
                        <div className="pt-4 pb-5 px-5">
                          <p className="mb-0">"Partnering with Brand Lift was a game changer for all our marketing & branding needs."</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="testimonial-item bg-light rounded h-100">
                        <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                          <img
                            className="img-fluid rounded"
                            src="/img/user.png"
                            style={{width: "60px", height: "60px"}}
                            alt="Client"
                          />
                          <div className="ps-4">
                            <h4 className="text-primary mb-1">David Hall</h4>
                            <small className="text-uppercase">Moving Company</small>
                          </div>
                        </div>
                        <div className="pt-4 pb-5 px-5">
                          <p className="mb-0">"The results were beyond our expectations, you are not just a service provider but magicians."</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="testimonial-item bg-light rounded h-100">
                        <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                          <img
                            className="img-fluid rounded"
                            src="/img/user.png"
                            style={{width: "60px", height: "60px"}}
                            alt="Client"
                          />
                          <div className="ps-4">
                            <h4 className="text-primary mb-1">Rahul Bensal</h4>
                            <small className="text-uppercase">Indian Restaurant</small>
                          </div>
                        </div>
                        <div className="pt-4 pb-5 px-5">
                          <p className="mb-0">"Awesome team – we loved your strategic approach like enhancing social media engagement & more..."</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Second Row - 2 Testimonials */}
                <div className={`carousel-item ${currentSlide === 1 ? 'active' : ''}`}>
                  <div className="row g-4 justify-content-center">
                    <div className="col-lg-6 col-md-6">
                      <div className="testimonial-item bg-light rounded h-100">
                        <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                          <img
                            className="img-fluid rounded"
                            src="/img/user.png"
                            style={{width: "60px", height: "60px"}}
                            alt="Client"
                          />
                          <div className="ps-4">
                            <h4 className="text-primary mb-1">Mike Adam</h4>
                            <small className="text-uppercase">Moving Company</small>
                          </div>
                        </div>
                        <div className="pt-4 pb-5 px-5">
                          <p className="mb-0">"We were impressed by your friendliness, expertise, and commitment to understanding our unique needs."</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="testimonial-item bg-light rounded h-100">
                        <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                          <img
                            className="img-fluid rounded"
                            src="/img/user.png"
                            style={{width: "60px", height: "60px"}}
                            alt="Client"
                          />
                          <div className="ps-4">
                            <h4 className="text-primary mb-1">Cathy M.</h4>
                            <small className="text-uppercase">Self-Storage Company</small>
                          </div>
                        </div>
                        <div className="pt-4 pb-5 px-5">
                          <p className="mb-0">"We are thankful and grateful to Brand Lift who significantly boosted our online presence."</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Carousel Controls */}
              <button 
                className="carousel-control-prev" 
                type="button" 
                onClick={goToPrevious}
                style={{left: "-50px"}}
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button 
                className="carousel-control-next" 
                type="button" 
                onClick={goToNext}
                style={{right: "-50px"}}
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
              
              {/* Carousel Indicators */}
              <div className="carousel-indicators">
                <button 
                  type="button" 
                  className={currentSlide === 0 ? 'active' : ''}
                  onClick={() => goToSlide(0)}
                  aria-current={currentSlide === 0 ? 'true' : 'false'}
                  aria-label="Slide 1"
                ></button>
                <button 
                  type="button" 
                  className={currentSlide === 1 ? 'active' : ''}
                  onClick={() => goToSlide(1)}
                  aria-current={currentSlide === 1 ? 'true' : 'false'}
                  aria-label="Slide 2"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Testimonial End */}
      
    </>

  );
}

export default Testimonials;